export const validarFormulario = (campos, requeridos) => {
    const errores = {};
    requeridos.forEach(campo => {
      const valor = campos[campo];
      if (valor === undefined || valor === null || (typeof valor === 'string' && !valor.trim())) {
        errores[campo] = 'Este campo es obligatorio';
      }
    });
    if (campos.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(campos.email)) {
      errores.email = 'Email inválido';
    }
    if (campos.monto !== undefined && campos.monto !== '' && parseFloat(campos.monto) <= 0) {
      errores.monto = 'El monto debe ser mayor a 0';
    }
    if (campos.stock !== undefined && campos.stock !== '' && parseInt(campos.stock) < 0) {
      errores.stock = 'El stock no puede ser negativo';
    }
    return errores;
  };